import { Inject } from 'vue-di-container';
import { Component, Vue, Watch } from 'vue-property-decorator';
import styles from './breadcrumb.module.scss';
import WithRender from './breadcrumb.html';
// models
import { BreadCrumbModel } from '@/models/breadcrumb';
// Services
import UserService from '@/services/user';
import { UserModel } from '@/models/user';

@WithRender
@Component({
  diProvide: [
    UserService,
  ],
})
export default class BreadCrumb extends Vue {
  @Inject(UserService)
  public userService!: UserService;

  public styles = styles;
  public showBreadCrumb = false;
  public isLoading = false;
  public user: UserModel = {} as UserModel;

  public baseBreadcrumb: BreadCrumbModel[] = [];
  public breadcrumbs: BreadCrumbModel[] = [];

  public get isLoggedInUser() {
    return Object.keys(this.user).length > 0;
  }

  public get isHighlighted() {
    const { path, meta } = this.$route;
    const dynamicallyHighlightedFromRouter = meta?.highlighted || false;
    const highlightedRoutes: string[] = [];

    return highlightedRoutes.includes(path.toLocaleLowerCase()) || dynamicallyHighlightedFromRouter;
  }

  async mounted() {
    this.isLoading = true;

    this.user = await this.userService.getUser();

    this.appendDynamicBreadcrumbs();

    this.isLoading = false;
  }

  public appendDynamicBreadcrumbs() {
    const { isLoggedInUser } = this;
    const requiredText = isLoggedInUser ? 'dashboard' : 'home';
    const requiredApp = isLoggedInUser ? 'dashboard' : 'landing';

    const initialBreadCrumbs = [
      {
        external: true,
        text: this.$t(requiredText).toString(),
        href: `/applications/${requiredApp}`,
      },
    ];

    this.breadcrumbs = [...initialBreadCrumbs];
    this.baseBreadcrumb = [...initialBreadCrumbs];

    this.updateBreadCrumbs();
  }

  @Watch('$route')
  public updateBreadCrumbs() {
    this.showBreadCrumb = this.$route.fullPath !== '/' && !this.$route.fullPath.startsWith('/#');

    let enhancedBreadcrumbs: BreadCrumbModel[] = [...this.baseBreadcrumb];

    this.$route.matched.forEach((route) => {
      const hasBreadcrumb = 'breadcrumb' in route.meta;

      if (hasBreadcrumb) {
        enhancedBreadcrumbs = enhancedBreadcrumbs.concat(route.meta.breadcrumb);
      } else {
        enhancedBreadcrumbs = [...this.baseBreadcrumb];
      }
    });

    // ? update [disabled/external] prop
    this.breadcrumbs = enhancedBreadcrumbs.map((route, index) => ({
      ...route,
      external: route.external || false,
      disabled: index === (enhancedBreadcrumbs.length - 1),
    }));
  }

  public onClickBreadcrumb(route: BreadCrumbModel) {
    this.$router.push(route.href || '');
  }
}
